/**
 * MoreView tabs — the parent view (`#/more`) has two children:
 *
 *   ┌──────────────────────────────────────────────────────┐
 *   │ 周报索引    │    更新日志                            │   ← tab strip
 *   ├──────────────────────────────────────────────────────┤
 *   │ <active child view content>                          │
 *   └──────────────────────────────────────────────────────┘
 *
 * The strip is rendered above the child content (which is appended by
 * `more.ts` after this component mounts). Clicking a tab fires
 * `onChange(child)` so the parent can swap children in-place rather
 * than route. The route is also kept in sync via `navigate()` so the
 * URL stays accurate.
 */

import { el } from "../dom";
import { navigate } from "../router";

export type MoreChild = "weeks" | "changelog";

export interface MoreTabsOptions {
  active: MoreChild;
}

export function moreSubsectionTabs({ active }: MoreTabsOptions): HTMLElement {
  const items: { key: MoreChild; label: string; hash: string }[] = [
    { key: "weeks", label: "周报索引", hash: "#/more" },
    { key: "changelog", label: "更新日志", hash: "#/more/changelog" },
  ];

  const root = el("div", { class: "more-tabs", role: "tablist", "aria-label": "更多" }, [
    ...items.map((it) =>
      el(
        "button",
        {
          type: "button",
          class: `more-tab${active === it.key ? " is-active" : ""}`,
          role: "tab",
          "data-key": it.key,
          "aria-selected": active === it.key ? "true" : "false",
          onclick: () => navigate(it.hash),
        },
        it.label,
      ),
    ),
  ]);

  return root;
}